/**
 * Freezing to prevent values being overridden accidentally at runtime
 *
 * @property {string} SUPER_ADMIN
 * @property {string} ADMIN
 * @property {string} USER
 */
export const ROLE = Object.freeze({
  SUPER_ADMIN: 'super-admin',
  ADMIN: 'admin',
  USER: 'user',
});
